/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const HEADING_TEXT = 'Identity & Access';
export const SELECT_LOCATION = 'Select Sub-Realm';
export const LOCATION_TOOLTIP = 'Use this button to switch between Realm and Sub-Realm views';
export const REALM = 'Realm';
export const NO_RESULT_FOUND = "No results found";

export const LOCATION = 'Sub-Realm';
export const CANCEL_BTN_TEXT = 'Cancel';
export const SELECT = 'Select';

export const PLEASE_TRY_A_DIFFERENT_MACHINE = "Please try a different machine";
export const PLEASE_TRY_A_DIFFERENT_USER = "Please try a different user";
export const PLEASE_TRY_A_DIFFERENT_ROLE = "Please try a different role";

export const DELETE_MACHINE_TITLE = 'Are you sure you want to delete the machine ';
export const NO_PERMISSION = 'You do not have any permission to view Identity and Access application, please contact your system administrator.'
export const ERROR_TEXT = 'There is some problem in {0}, please contact your system administrator.'
export const EXPORT_SUCCESS_MESSAGE = 'Roles successfully exported as resource. Go to Application Lifecycle Management (ALM) to deploy it to another realm.';
export const AdminRealmIdList = [
  { realmId: '7520eb93-b0a8-432f-9c94-c9583a470222' }, // liam-test
  { realmId: '3d30d779-743a-41a8-bb78-22405300fb96' }, // liam-us
  { realmId: '00ca84fa-534b-4af3-841d-10704eb35c40' }, // liam-apac
  { realmId: '57bfe6c3-73ec-49ec-a627-e792133247a6' }, // liam-eu
  { realmId: 'f1635f28-665b-4577-b965-c2338b33f09c' }, // liam-dev
];
